var map = {
	"./config.yml": "7288",
	"./content/a2.md": "22d0",
	"./content/front_detection.md": "83c8",
	"./content/introduction.md": "66c1",
	"./content/land_pollution.md": "31e2",
	"./content/legal.md": "53cf",
	"./content/marine_conditions.md": "7465",
	"./content/site_prospection.md": "ae46",
	"./content/sm-info/a1-info.md": "8100",
	"./content/sm-info/a2-info.md": "d56a",
	"./content/sm-info/a3-info.md": "15b9",
	"./content/sm-info/a4-info.md": "1ace",
	"./content/sm-info/f1-info.md": "8ad3",
	"./content/sm-info/f2-info.md": "a55e",
	"./content/sm-info/r1-info.md": "c161",
	"./content/source_retrieval.md": "dc7c",
	"./content/spat_capture.md": "05e3",
	"./content/spat_capture_assistance.md": "d23b",
	"./content/suitable_fishing_areas.md": "c5ee",
	"./content/user-agreements.md": "13e6",
	"./examples/example_a3.jpg": "7692",
	"./examples/example_a4.jpg": "21be2",
	"./examples/example_eforie_a2.jpg": "ad97",
	"./examples/example_galway_a2.jpg": "b1df",
	"./examples/example_galway_r1.jpg": "6872",
	"./examples/example_limfjord_a1.jpg": "80b6",
	"./examples/example_sado_estuary_a1.jpg": "964a",
	"./examples/example_southern_north_sea_r1.jpg": "9b60",
	"./examples/no-data.jpg": "8539",
	"./services/services": "f7dd",
	"./services/services.json": "f7dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4975";